// extracted by mini-css-extract-plugin
export default {"isContainer":"stack_isContainer__3wRje","stack":"stack_stack__3rOPt","horizontal":"stack_horizontal__3Ah41","item":"stack_item__1U3qf"};